import(/* webpackMode: "eager", webpackExports: ["SlowdownView"] */ "/vercel/path0/translations/ja/Endings.tsx");
